
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2329',
  depVersions: {
  "customer-portal-app": "static-1.2329",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9675",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25389",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5598",
  "hs-test-utils": "static-1.8019",
  "hub-http": "static-1.6228",
  "hub-http-shared-msw-handlers": "static-1.9973",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18244",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11477",
  "I18n": "static-7.1628",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6470",
  "payment-link-components": "static-1.23548",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7040",
  "quartz-core": "static-1.6259",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10213",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5348",
  "rich-text-lib": "static-1.19849",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18003",
  "ui-components-test-utils": "static-1.5614",
  "UIComponents": "static-3.8423",
  "foundations-assets": "static-1.4871",
  "foundations-components": "static-1.7950",
  "foundations-theming": "static-1.4424",
  "foundations-theming-specialty": "static-1.2140",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.905",
  "quartz-config": "static-1.818",
  "quartz-routing": "static-1.470",
  "quick-fetch": "static-1.3920",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16678",
  "rpc-client-utils": "static-1.4658",
  "sanitize-text": "static-1.8148",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4768",
  "ui-addon-react-router-dom": "static-1.9548",
  "usage-tracker": "static-1.7350",
  "usage-tracker-anonymous": "static-1.5767",
  "usage-tracker-core": "static-1.7200",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3402",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3317",
  "quartz-webpack": "static-1.3264",
  "bend-plugin-quartz-routing": "static-1.118",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7675",
  "frontend-preferences-client": "static-1.7934",
  "laboratory-lib": "static-3.7162",
  "onboarding-scopes": "static-1.6468",
  "ui-addon-opt": "static-4.8374",
  "HeadJS": "static-2.762",
  "hs-test-utils-bend-plugin": "static-1.3130",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.84",
  "ts-schema": "static-1.4083",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7763",
  "cssUtils": "static-1.794",
  "customer-data-ui-utilities": "static-1.9833",
  "HubStyle": "static-2.11784",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.715",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9894",
  "ui-addon-i18n": "static-1.11155",
  "ui-business-units-lib": "static-1.9061",
  "ui-shepherd-react": "static-3.10169",
  "video-components-external": "static-1.11279",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4333",
  "commerce-tours-lib": "static-1.6111",
  "customer-data-properties": "static-1.51565",
  "getting-started-shared-tasks": "static-1.18479",
  "growth-onboarding-reliability": "static-1.5088",
  "onboarding-tours": "static-1.16623",
  "reference-resolvers-lite": "static-1.8100",
  "sales-checkout-service-client": "static-1.3646",
  "ui-addon-iframeable": "static-1.9064",
  "user-context": "static-1.5112",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4655",
  "icons": "static-2.647",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.715",
  "quartz-head": "static-1.705",
  "quartz-test": "static-1.715",
  "quartz-tracking": "static-1.419",
  "ui-fonts": "static-1.739",
  "usage-tracker-container": "static-1.7340",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9431",
  "data-token-picker": "static-1.16423",
  "FileManagerLib": "static-1.39283",
  "property-translator": "static-1.5407",
  "atom": "static-1.5078",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5913",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5433",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-components": "static-1.4219",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "trellis-assets": "static-1.1966",
  "bend-plugin-foundations-theming": "static-1.2907",
  "foundations-theming-base": "static-1.3409",
  "stylex": "static-1.33",
  "interframe": "static-3.4766",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5764",
  "web-vitals": "static-1.5",
  "bend-plugin-chirp-manifest": "static-1.68",
  "chirp-fetch": "static-1.1894",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4483",
  "react-flip-move": "static-1.70",
  "bender-build-tools": "static-1.3205",
  "inbound-db-properties-service-client": "static-1.3849",
  "superstore": "static-1.4767",
  "feedback-loader": "static-1.29308",
  "ai-components-ui-library": "static-1.8996",
  "ui-addon-video-player": "static-1.8709",
  "ui-coaching-tips": "static-1.28568",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4621",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2502",
  "magpie-lib": "static-1.5555",
  "navigation-messaging": "static-1.7387",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8177",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4657",
  "content-media-composition-data-lib": "static-1.12314",
  "content-media-compositions": "static-2.16321",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4161",
  "magpie-types": "static-1.5015",
  "media-bridge-lib": "static-1.18940",
  "video-data-lib": "static-1.34937",
  "commerce-products-lib": "static-1.9580",
  "crm-message-bus": "static-1.43001",
  "growth-data-modal": "static-1.5440",
  "hubspot-apollo-client": "static-1.4885",
  "onboarding-tours-client": "static-1.4837",
  "calling-global-api": "static-1.64524",
  "calling-internal-common": "static-1.31309",
  "calling-lifecycle-internal": "static-1.65906",
  "calling-lifecycle-messages": "static-1.58200",
  "conditional-properties-service-client": "static-1.3800",
  "crm-links": "static-1.6300",
  "customer-data-objects-ui-components": "static-1.13033",
  "customer-data-properties-shared-msw-handlers": "static-1.9300",
  "customer-data-property-utils": "static-1.8096",
  "external-options-client-types": "static-1.4162",
  "file-manager-components": "static-1.23643",
  "framework-data-schema-resolvers": "static-1.6891",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.156",
  "inbound-db-meta-service-client": "static-1.3589",
  "inbounddb-objects-service-types": "static-1.4226",
  "meetings-icalendar-utils-lib": "static-1.637",
  "multi-currency-client-types": "static-1.3694",
  "object-builder-ui-client": "static-1.48760",
  "pipeline-validation-client-types": "static-1.3968",
  "property-value-citations": "static-1.2179",
  "pulse": "static-1.580",
  "smart-property-lib": "static-1.7072",
  "tiered-pricing": "static-1.1233",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.10996",
  "growth-onboarding-confetti": "static-1.3072",
  "growth-onboarding-next-action-utils": "static-1.1930",
  "navigation-components": "static-1.18060",
  "onboarding-tours-utils": "static-1.689",
  "ui-shepherd-tracker": "static-1.7550",
  "ui-universal-auth": "static-1.8985",
  "batch-promise": "static-1.1547",
  "getting-started-shared-tasks-store": "static-1.17597",
  "hubspotter-http-shared-msw-handlers": "static-1.9971",
  "usage-tracker-session-replay": "static-1.5036",
  "audio-components": "static-1.5926",
  "FileManagerCore": "static-1.39142",
  "FileManagerImages": "static-1.36794",
  "video-components": "static-1.13282",
  "foundations-components-legacy": "static-1.975",
  "purchase-motions-api": "static-1.5916",
  "self-service-api": "static-1.10254",
  "signup-constants": "static-1.18848",
  "signup-ui-url-generator": "static-2.8055",
  "trials-service-types": "static-1.3909",
  "usage-tracker-public": "static-1.7161",
  "chatspot-core": "static-1.21354",
  "ContentUtils": "static-1.68377",
  "copilot-toolkit": "static-1.11149",
  "growth-onboarding-feedback-components": "static-1.6587",
  "reactive-lib": "static-1.730",
  "simple-logging-lib": "static-1.3056",
  "commerce-permissions": "static-1.775",
  "customer-data-tracking": "static-1.6895",
  "products-iframe-lib": "static-1.7944",
  "products-ui-components-shared-msw-handlers": "static-1.10355",
  "restore-request-side-panel-lib": "static-1.905",
  "onboarding-data-sync-lib": "static-1.1969",
  "hubspot-apollo-cache": "static-1.344",
  "calling-error-reporting": "static-1.31316",
  "shared-worker-versioning": "static-1.11042",
  "calling-usage-tracker": "static-1.6547",
  "voice-sms-access-library": "static-1.988",
  "conversations-skeleton-state": "static-1.7253",
  "location-customization-utils-lib": "static-1.9271",
  "crm-pipelines-api-client-types": "static-1.4142",
  "fdsr-migration-layer": "static-1.10",
  "framework-builder-read-service-client": "static-1.4008",
  "framework-data-schema-quick-fetch": "static-1.6796",
  "persist-promise": "static-1.3704",
  "bend-plugin-pulse": "static-1.83",
  "directed-graph": "static-1.942",
  "event-emitter": "static-1.954",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.203",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10056",
  "fsm": "static-1.3736",
  "policy-lib": "static-1.6784",
  "react-tinymce": "static-1.55253",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10119",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54379",
  "tinymce-plugins": "static-1.57493",
  "tinymce-themes": "static-1.56349",
  "growth-onboarding-next-action-components": "static-1.1958",
  "user-context-client": "static-1.4619",
  "nest": "static-1.232",
  "unified-auth-core-lib": "static-1.781",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4543",
  "video-embed": "static-1.35771",
  "content-icons-ui": "static-1.2229",
  "social-insights-client-types": "static-1.22122",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4818",
  "integrations-lib": "static-1.16155",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4265",
  "InboxConnectUtils": "static-4.14823",
  "meetings-connect-utils-lib": "static-1.7611",
  "calling-orchestration-schema": "static-1.35765",
  "crm-record-cards-service-types": "static-1.3600",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4522",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3049",
  "tinymce-data": "static-1.40464",
  "ui-addon-sales-email": "static-1.5217",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12462",
  "layout-dnd-utils": "static-1.11437",
  "react-codemirror": "static-1.10633",
  "ui-brand-identity-lib": "static-1.15294",
  "NamespacedHubStyle": "static-2.9062",
  "outpost": "static-1.4188",
  "flux-actions": "static-1.338",
  "integrations-error-boundary-lib": "static-1.13570",
  "integrations-tracking-lib": "static-1.5607",
  "native-integrations-shared-strings": "static-1.7788",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10371",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.499",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68452",
  "layout-data-lib": "static-1.9762",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3018",
  "google-sheets-integration-lib": "static-1.247",
  "microsoft-drive-integration-lib": "static-1.366",
  "slack-ui-library": "static-1.10399",
  "advanced-menus-core": "static-1.15139",
  "advanced-menus-lib": "static-1.12078",
  "ExportDialog": "static-6.10395",
  "ui-memberships-settings-lib": "static-1.34057",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15138",
  "simple-menus-lib": "static-1.16655"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2329",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9675",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25389",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5598",
  "hs-test-utils": "/hs-test-utils/static-1.8019",
  "hub-http": "/hub-http/static-1.6228",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9973",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18244",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11477",
  "I18n": "/I18n/static-7.1628",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6470",
  "payment-link-components": "/payment-link-components/static-1.23548",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7040",
  "quartz-core": "/quartz-core/static-1.6259",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10213",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5348",
  "rich-text-lib": "/rich-text-lib/static-1.19849",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18003",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5614",
  "UIComponents": "/UIComponents/static-3.8423",
  "foundations-assets": "/foundations-assets/static-1.4871",
  "foundations-components": "/foundations-components/static-1.7950",
  "foundations-theming": "/foundations-theming/static-1.4424",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2140",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.905",
  "quartz-config": "/quartz-config/static-1.818",
  "quartz-routing": "/quartz-routing/static-1.470",
  "quick-fetch": "/quick-fetch/static-1.3920",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16678",
  "rpc-client-utils": "/rpc-client-utils/static-1.4658",
  "sanitize-text": "/sanitize-text/static-1.8148",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4768",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9548",
  "usage-tracker": "/usage-tracker/static-1.7350",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5767",
  "usage-tracker-core": "/usage-tracker-core/static-1.7200",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3402",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3317",
  "quartz-webpack": "/quartz-webpack/static-1.3264",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.118",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7675",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7934",
  "laboratory-lib": "/laboratory-lib/static-3.7162",
  "onboarding-scopes": "/onboarding-scopes/static-1.6468",
  "ui-addon-opt": "/ui-addon-opt/static-4.8374",
  "HeadJS": "/HeadJS/static-2.762",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3130",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.84",
  "ts-schema": "/ts-schema/static-1.4083",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7763",
  "cssUtils": "/cssUtils/static-1.794",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9833",
  "HubStyle": "/HubStyle/static-2.11784",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.715",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9894",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11155",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9061",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10169",
  "video-components-external": "/video-components-external/static-1.11279",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4333",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6111",
  "customer-data-properties": "/customer-data-properties/static-1.51565",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18479",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5088",
  "onboarding-tours": "/onboarding-tours/static-1.16623",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8100",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3646",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9064",
  "user-context": "/user-context/static-1.5112",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4655",
  "icons": "/icons/static-2.647",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.715",
  "quartz-head": "/quartz-head/static-1.705",
  "quartz-test": "/quartz-test/static-1.715",
  "quartz-tracking": "/quartz-tracking/static-1.419",
  "ui-fonts": "/ui-fonts/static-1.739",
  "usage-tracker-container": "/usage-tracker-container/static-1.7340",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9431",
  "data-token-picker": "/data-token-picker/static-1.16423",
  "FileManagerLib": "/FileManagerLib/static-1.39283",
  "property-translator": "/property-translator/static-1.5407",
  "atom": "/atom/static-1.5078",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5913",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5433",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4219",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "trellis-assets": "/trellis-assets/static-1.1966",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2907",
  "foundations-theming-base": "/foundations-theming-base/static-1.3409",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4766",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5764",
  "web-vitals": "/web-vitals/static-1.5",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.68",
  "chirp-fetch": "/chirp-fetch/static-1.1894",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4483",
  "react-flip-move": "/react-flip-move/static-1.70",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3849",
  "superstore": "/superstore/static-1.4767",
  "feedback-loader": "/feedback-loader/static-1.29308",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8996",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8709",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28568",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4621",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2502",
  "magpie-lib": "/magpie-lib/static-1.5555",
  "navigation-messaging": "/navigation-messaging/static-1.7387",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8177",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4657",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12314",
  "content-media-compositions": "/content-media-compositions/static-2.16321",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4161",
  "magpie-types": "/magpie-types/static-1.5015",
  "media-bridge-lib": "/media-bridge-lib/static-1.18940",
  "video-data-lib": "/video-data-lib/static-1.34937",
  "commerce-products-lib": "/commerce-products-lib/static-1.9580",
  "crm-message-bus": "/crm-message-bus/static-1.43001",
  "growth-data-modal": "/growth-data-modal/static-1.5440",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4885",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4837",
  "calling-global-api": "/calling-global-api/static-1.64524",
  "calling-internal-common": "/calling-internal-common/static-1.31309",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65906",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58200",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3800",
  "crm-links": "/crm-links/static-1.6300",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13033",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9300",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8096",
  "external-options-client-types": "/external-options-client-types/static-1.4162",
  "file-manager-components": "/file-manager-components/static-1.23643",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6891",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.156",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3589",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4226",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.637",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3694",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48760",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3968",
  "property-value-citations": "/property-value-citations/static-1.2179",
  "pulse": "/pulse/static-1.580",
  "smart-property-lib": "/smart-property-lib/static-1.7072",
  "tiered-pricing": "/tiered-pricing/static-1.1233",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10996",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3072",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1930",
  "navigation-components": "/navigation-components/static-1.18060",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.689",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7550",
  "ui-universal-auth": "/ui-universal-auth/static-1.8985",
  "batch-promise": "/batch-promise/static-1.1547",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17597",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9971",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5036",
  "audio-components": "/audio-components/static-1.5926",
  "FileManagerCore": "/FileManagerCore/static-1.39142",
  "FileManagerImages": "/FileManagerImages/static-1.36794",
  "video-components": "/video-components/static-1.13282",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.975",
  "purchase-motions-api": "/purchase-motions-api/static-1.5916",
  "self-service-api": "/self-service-api/static-1.10254",
  "signup-constants": "/signup-constants/static-1.18848",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8055",
  "trials-service-types": "/trials-service-types/static-1.3909",
  "usage-tracker-public": "/usage-tracker-public/static-1.7161",
  "chatspot-core": "/chatspot-core/static-1.21354",
  "ContentUtils": "/ContentUtils/static-1.68377",
  "copilot-toolkit": "/copilot-toolkit/static-1.11149",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6587",
  "reactive-lib": "/reactive-lib/static-1.730",
  "simple-logging-lib": "/simple-logging-lib/static-1.3056",
  "commerce-permissions": "/commerce-permissions/static-1.775",
  "customer-data-tracking": "/customer-data-tracking/static-1.6895",
  "products-iframe-lib": "/products-iframe-lib/static-1.7944",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10355",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.905",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1969",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.344",
  "calling-error-reporting": "/calling-error-reporting/static-1.31316",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11042",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6547",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.988",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7253",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9271",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4142",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.10",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4008",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6796",
  "persist-promise": "/persist-promise/static-1.3704",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.83",
  "directed-graph": "/directed-graph/static-1.942",
  "event-emitter": "/event-emitter/static-1.954",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.203",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10056",
  "fsm": "/fsm/static-1.3736",
  "policy-lib": "/policy-lib/static-1.6784",
  "react-tinymce": "/react-tinymce/static-1.55253",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10119",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54379",
  "tinymce-plugins": "/tinymce-plugins/static-1.57493",
  "tinymce-themes": "/tinymce-themes/static-1.56349",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1958",
  "user-context-client": "/user-context-client/static-1.4619",
  "nest": "/nest/static-1.232",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.781",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4543",
  "video-embed": "/video-embed/static-1.35771",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "social-insights-client-types": "/social-insights-client-types/static-1.22122",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4818",
  "integrations-lib": "/integrations-lib/static-1.16155",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4265",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14823",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7611",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35765",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3600",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4522",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3049",
  "tinymce-data": "/tinymce-data/static-1.40464",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5217",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12462",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11437",
  "react-codemirror": "/react-codemirror/static-1.10633",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15294",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9062",
  "outpost": "/outpost/static-1.4188",
  "flux-actions": "/flux-actions/static-1.338",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13570",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5607",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7788",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10371",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.499",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68452",
  "layout-data-lib": "/layout-data-lib/static-1.9762",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3018",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.247",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.366",
  "slack-ui-library": "/slack-ui-library/static-1.10399",
  "advanced-menus-core": "/advanced-menus-core/static-1.15139",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12078",
  "ExportDialog": "/ExportDialog/static-6.10395",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34057",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15138",
  "simple-menus-lib": "/simple-menus-lib/static-1.16655"
}
};
